import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { last, switchMap } from 'rxjs/operators';

export abstract class SequentialGuardCombinator  {

  guards: {
    canActivate: CanActivateFn;
}[];

  constructor(...guards: {
    canActivate: CanActivateFn;
}[]) {
    this.guards = guards;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<(boolean | UrlTree)> {
    let observables$ = of(true) as Observable<boolean | UrlTree>;

    for (let i = 0; i < this.guards.length; i++) {
      observables$ = this.handleNextResult(route, state, observables$, this.guards[i]);
    }

    observables$ = this.handleNextResult(route, state, observables$, null);

    return observables$.pipe(last());
  }

  handleNextResult(route: ActivatedRouteSnapshot, state: RouterStateSnapshot,
    observables$: Observable<boolean | UrlTree>, nextGuard$: {
    canActivate: CanActivateFn;
} = null): Observable<boolean | UrlTree> {
    return observables$.pipe(switchMap((next: boolean | UrlTree) => {
      const urlTree = next as UrlTree;
      if (urlTree != null && urlTree.toString() === state.url)
        return of(true);

      if (next === true && nextGuard$ !== null)
          return nextGuard$.canActivate(route, state) as Observable<boolean | UrlTree>;

      return of(next);
    }));
  }
}
